import type { ChainWeightingMode } from '~/types/services/priceParrot';

export const chainParityQueryKeys = {
  all: ['chain-parity'] as const,
  lists: () => [...chainParityQueryKeys.all, 'list'] as const,
  list: (dateFrom: string, dateTo: string) => [...chainParityQueryKeys.lists(), dateFrom, dateTo] as const,
  chains: () => [...chainParityQueryKeys.all, 'chain'] as const,
  series: (
    chainName: string,
    dateFrom: string,
    dateTo: string,
    weighting: ChainWeightingMode,
    continent: string | null,
  ) =>
    [...chainParityQueryKeys.chains(), chainName, 'series', dateFrom, dateTo, weighting, continent ?? 'all'] as const,
  summary: (
    chainName: string,
    dateFrom: string,
    dateTo: string,
    weighting: ChainWeightingMode,
    continent: string | null,
  ) =>
    [...chainParityQueryKeys.chains(), chainName, 'summary', dateFrom, dateTo, weighting, continent ?? 'all'] as const,
  properties: (
    chainName: string,
    dateFrom: string,
    dateTo: string,
    limit: number,
    continent: string | null,
    weighting: ChainWeightingMode,
  ) =>
    [
      ...chainParityQueryKeys.chains(),
      chainName,
      'properties',
      dateFrom,
      dateTo,
      limit,
      continent ?? 'all',
      weighting,
    ] as const,
  competitors: (chainName: string, dateFrom: string, dateTo: string, continent: string | null) =>
    [...chainParityQueryKeys.chains(), chainName, 'competitors', dateFrom, dateTo, continent ?? 'all'] as const,
};
